import React from "react";
import {
  OtherAgileIcon,
  OtherReleaseIcon,
  OtherEpicIcon,
  ResourcesIcon,
  QAtestingIcon,
} from "app/components/Icons";

export const DefaultCustomizationList = [
  {
    id: "agileDevelopmentAndSprints",
    title: "Agile Development and Sprints",
    caption: "Enables teams to adopt Agile methodologies, particularly Scrum",
    color: "#6bd60e26",
    icon: <OtherAgileIcon size={20}/>,
  },
  {
    id: "epicsAndStories",
    title: "Epics and Stories",
    caption:
      "Facilitates the breakdown of large pieces of work into manageable components.",
    color: "#16e4e426",
    icon: <OtherEpicIcon size={20}/>,
  },
  {
    id: "releaseManagement",
    title: "Release Management",
    caption:
      "Facilitates the planning, tracking, and execution of software releases.",
    color: "#ff797926",
    icon: <OtherReleaseIcon size={20}/>,
  },
  {
    id: "resourceManagement",
    title: "Project Resources Management",
    caption:
      "Enables the team to manage project-related resources and important information. (coming soon).",
    color: "",
    icon: <ResourcesIcon size={20} />,
     isDisabled: true,
  },
  {
    id: "qaTesting",
    title: "QA Testing",
    caption:
      "Integrates quality assurance processes directly into the project management workflow.",
    color: "",
    icon: <QAtestingIcon size={20} />,
    isDisabled: true,
  },
];
